import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTTSStore } from '../store/tts';
import { useUserStore } from '../store/user';
import TextInput from '../components/TTS/TextInput';
import VoiceSelector from '../components/TTS/VoiceSelector';
import AudioPlayer from '../components/TTS/AudioPlayer';
import HistoryList from '../components/TTS/HistoryList';
import { UsageLimits } from '../components/User';

function TextToSpeechDashboard({
  title = 'Text to Speech',
  description = 'Convert text into natural speech with voice selection, playback, and conversion history.',
  defaultVoiceCleanerEnabled = false,
}) {
  const { fetchVoices, fetchHistory, fetchTextModels } = useTTSStore();
  const { fetchUsageStats } = useUserStore();

  useEffect(() => {
    fetchUsageStats();
    fetchVoices();
    fetchTextModels();
    fetchHistory();
  }, [fetchUsageStats, fetchVoices, fetchTextModels, fetchHistory]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <Link to="/dashboard" className="text-sm text-purple-400 hover:underline">
          ← Back to Dashboard
        </Link>
      </div>

      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2">{title}</h1>
        <p className="text-gray-400">{description}</p>
      </div>

      <div className="grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <div className="card">
            <h2 className="text-xl font-semibold mb-4">{title}</h2>
            {defaultVoiceCleanerEnabled && (
              <p className="text-sm text-purple-300 mb-4">
                ✨ Voice Cleaner mode is pre-enabled on this page for polished narration output.
              </p>
            )}
            <TextInput defaultVoiceCleanerEnabled={defaultVoiceCleanerEnabled} />
          </div>

          <div className="mt-6">
            <AudioPlayer />
          </div>

          <div className="mt-6">
            <HistoryList />
          </div>
        </div>

        <div className="space-y-6">
          <VoiceSelector />
          <UsageLimits />
        </div>
      </div>
    </div>
  );
}

export default TextToSpeechDashboard;
